<template>
  <div id="paper-root">
    <a-layout theme="light">
      <a-layout-header>
        <a-row id="paper-header">
          <a-col :span="10">
            <span @click="paperDescVisible=true"><a-icon v-if="paperInfo.paperDesc" type="question-circle" /> {{(paperDepart&&paperDepart.examName) || paperInfo.paperName}}</span>
          </a-col>
          <a-col :span="10">
            <span>{{$t('exam.student')}}：</span>
            <span class="remain-time">{{userInfo.realname}}</span>
            <a-divider type="vertical"/>
            <span>{{$t('exam.timeLimit')}}：{{paperInfo.timeLimit}}</span>
            <a-divider type="vertical"/>
            <span>{{$t('exam.spendTime')}}<span class="remain-time">{{formatTime(userPaperInfo.duration)}}</span></span>
            <a-divider type="vertical"/>
            <span>{{$t('exam.totalScore')}}:{{paperInfo.totalScore}}</span>
            <a-divider type="vertical"/>
            <span>{{$t('exam.gotScore')}}：<span class="remain-time">{{gotScore}}</span></span>
          </a-col>
          <a-col :span="4">
            <a-button :loading="submiting" type="primary" @click="requestReviewPaper">提交批改</a-button>
          </a-col>
        </a-row>
      </a-layout-header>
      <a-layout>
        <a-layout-sider :style="{ overflowY: 'auto' }">
          <a-card class="question-index">
            <a-row>
              <div v-for="(q, i) in paperQuestion" :key="i">
                <a-col class="question-section" :span="24" v-if="q.questionSection">{{ q.questionSection }}</a-col>
                <a-col :span="6">
                  <a-tag :color="isReviewAnswer(i) ? paperAnswer[i]['gotScore']==q.paperQuestionScore? 'green' : 'red' : ''" @click="jumpQuestion(i)">{{ i + 1 }}</a-tag>
                </a-col>
              </div>
            </a-row>
          </a-card>
          <p>{{$t('exam.tips')}}</p>
          <p>
            <span>正确&nbsp;</span><a-tag color="green">&nbsp;</a-tag>
            <span>错误&nbsp;</span><a-tag color="red">&nbsp;</a-tag>
            <span>未批&nbsp;</span><a-tag>&nbsp;</a-tag>
          </p>
        </a-layout-sider>
        <a-layout-content
          :style="{ minHeight: '80vh', height: 'calc(100vh - ' + heightOffset + 'px', overflow: 'auto' }"
        >
          <a-spin v-if="loading" tip="加载中..."></a-spin>
          <a-card class="paper-content" :bordered="false">
            <div v-for="(q, qi) in paperQuestion" :key="qi">
              <!-- 题块 -->
              <div class="question-section" v-if="q.questionSection">
                <h2>{{ questionSections[qi].text }}</h2>
                <h3> （共{{questionSections[qi].count}}题，每题{{q.paperQuestionScore}}分，共{{questionSections[qi].score}}分）</h3>
              </div>
              <a-card class="question-card" :id="'q-' + qi">
                <a-row>
                  <!-- 题干 -->
                  <a-col>
                    <div v-if="q.questionType != 4" class="question-stem">
                      <span>{{ qi + 1 }}. （{{ q.paperQuestionScore }}分）</span>
                      <span v-if="!isWriteAnswer(qi)" style="color:red">（未作答）</span>
                      <div v-html-md="q.questionStem"></div>
                    </div>
                    <div v-if="q.questionType == 4" :id="'question-stem-'+q.id" ></div>
                  </a-col>
                  <a-divider />
                  <a-col>
                    <!-- 单选 -->
                    <a-radio-group disabled v-if="q.questionType == 1" v-model="paperAnswer[qi]['myAnswer']">
                      <a-radio v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi">
                        <span class="question-letter">{{ index2letter(oi) }}</span>
                        <div class="question-options-content">
                          <div class="option" v-html-md="o.item"></div>
                        </div>
                      </a-radio>
                    </a-radio-group>
                    <!-- 多选 -->
                    <a-checkbox-group disabled v-if="q.questionType == 2" v-model="paperAnswer[qi]['myAnswer']">
                      <a-checkbox v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi">
                        <span class="question-letter">{{ index2letter(oi) }}</span>
                        <div class="question-options-content">
                          <div class="option" v-html-md="o.item"></div>
                        </div>
                      </a-checkbox>
                    </a-checkbox-group>
                    <!-- 判断题 -->
                    <a-radio-group disabled v-if="q.questionType == 3" v-model="paperAnswer[qi]['myAnswer']">
                      <a-radio value="true"><span class="question-letter">{{ index2letter(0) }}</span>{{$t('exam.right')}}</a-radio>
                      <a-radio value="false"><span class="question-letter">{{ index2letter(1) }}</span>{{$t('exam.wrong')}}</a-radio>
                    </a-radio-group>
                    <!-- 填空题 -->
                    <!-- 已改为虚拟DOM，直接在题干的下划线展示答案 -->
                    <!-- <div v-if="q.questionType == 4">
                      <a-input
                        readOnly
                        v-for="oi in q.questionOptions.fillGapNum"
                        :key="oi"
                        v-model="paperAnswer[qi]['myAnswer'][oi - 1]"
                        :placeholder="'第' + oi + '空回答'"
                      />
                    </div> -->
                    <!-- 主观题 阅读分析-->
                    <div v-if="q.questionType == 5 || q.questionType == 6">
                      <a-textarea
                        readOnly
                        :auto-size="{ minRows: 5, maxRows: 20 }"
                        :placeholder="$t('exam.answerArex')"
                        v-model="paperAnswer[qi]['myAnswer']"
                      ></a-textarea>
                    </div>

                    <!-- 编程题 -->
                    <div v-if="q.questionType == 7">
                      <a-button type="primary" size="large" @click="openEditor(q)" :disabled="!isWriteAnswer(qi)">{{$t('exam.viewAnswer')}}</a-button>
                    </div>

                    <!-- OJ编程题 -->
                    <div v-if="q.questionType == 8">
                      <a-button type="primary" size="large" @click="openEditor(q)" :disabled="!isWriteAnswer(qi)">{{$t('exam.viewAnswer')}}</a-button>
                    </div>
                    <!-- 文件题 -->
                    <div v-if="q.questionType == 9">
                      <video v-if="q.questionOptions.uploadTarget==2||q.questionOptions.uploadTarget==3" :src="getQiniuUrl(q.myAnswerFile)" controls></video>
                      <a v-else :href="getQiniuUrl(q.myAnswerFile)">点击查看文件</a>
                    </div>
                  </a-col>
                </a-row>
                <a-divider />
                <a-row>
                  <a-col :span="8">
                    <p>{{$t('exam.answer')}}:
                      <span>{{answer2Text(paperQuestion[qi])}}</span>
                    </p>
                  </a-col>
                  <a-col :span="10">
                    <!-- 单选、多选、判断批改 -->
                    <span v-if="q.questionType == 1 || q.questionType == 2 || q.questionType == 3">
                      <a-button type="primary" shape="circle" icon="check" @click="paperAnswer[qi]['gotScore']=q.paperQuestionScore"/>
                      <a-divider type="vertical"/>
                      <a-button type="danger" shape="circle" icon="close" @click="paperAnswer[qi]['gotScore']=0"/>
                      <a-divider type="vertical"/>
                    </span>
                    <span v-else>
                      <a-button type="primary" @click="paperAnswer[qi]['gotScore']=q.paperQuestionScore">{{$t('exam.right')}}</a-button>
                      <a-divider type="vertical"/>
                      <a-button type="danger" @click="paperAnswer[qi]['gotScore']=0">{{$t('exam.wrong')}}</a-button>
                      <a-divider type="vertical"/>
                    </span>
                    <a-input style="width:180px;" :addon-before="$t('exam.gotScore')" type="number" :min="0" :max="q.paperQuestionScore" v-model="paperAnswer[qi]['gotScore']"></a-input>
                  </a-col>
                  <a-col :span="6">
                    <a-textarea :auto-size="{ minRows: 2, maxRows: 10 }" :placeholder="$t('exam.comment')" v-model="paperAnswer[qi]['reviewComment']"></a-textarea>
                  </a-col>
                  <a-col :span="24" v-if="q.myTestCase">
                    <a-divider>测试用例</a-divider>
                    <a-row :gutter="[16,16]">
                      <a-col :span="3">用例名称</a-col>
                      <a-col :span="2">得分</a-col>
                      <a-col :span="5">输入</a-col>
                      <a-col :span="7">输出</a-col>
                      <a-col :span="7">错误</a-col>
                    </a-row>
                    <a-row v-for="(c,i) in JSON.parse(q.myTestCase)" :key="i" :gutter="[16,16]">
                      <a-col :span="3">{{c.name}}</a-col>
                      <a-col :span="2">{{c.gotScore}}</a-col>
                      <a-col :span="5"><j-ellipsis :value="c.input" :length="80" /></a-col>
                      <a-col :span="7"><j-ellipsis :value="c.output" :length="80" /></a-col>
                      <a-col :span="7">
                        <a-tooltip placement="top">
                          <template slot="title">
                            <p>{{c.message}}</p>
                            <br>
                            <p>{{c.stderr}}</p>
                          </template>
                          {{c.error}}
                        </a-tooltip>
                      </a-col>
                    </a-row>
                  </a-col>
                </a-row>
              </a-card>
            </div>
          </a-card>
        </a-layout-content>
      </a-layout>
    </a-layout>
    <a-modal
      :width="'800px'"
      :visible="paperDescVisible"
      :title="$t('exam.paperDesc')"
      :destroyOnClose="true"
      :footer="null"
      @cancel="paperDescVisible=false"
    >
      <div v-html-md="paperInfo.paperDesc"></div>
    </a-modal>
    <!-- 编辑器 -->
    <a-modal :width="'100%'" :visible="editorVisible" :maskClosable="false" :dialogStyle="{top: 0}" :bodyStyle="{padding:0}"
      :destroyOnClose="true" :footer="null" @cancel="editorVisible=false">
      <a-icon slot="closeIcon" type="close-circle" theme="twoTone" style="font-size: 30px;line-height: 70px;"/>
      <div slot="title">
        <a-row>
           <a-col :span="8">
            <span>{{currentQuestionInfo.questionName}}</span>
           </a-col>
          <a-col :span="8">
            <a-button v-if="currentQuestionInfo.questionType!=8" type="primary" @click="viewStemVisible=true">{{$t('exam.viewQuestionStem')}}</a-button>
          </a-col>
        </a-row>
        </div>
      <iframe :src="editorUrl" id="player" frameborder="0" width="100%" style="height:calc(100vh - 70px);"
        scrolling="no"></iframe>
    </a-modal>
     <!-- 查看题干 -->
    <a-modal :width="800" :visible="viewStemVisible" :footer="null" @cancel="viewStemVisible=false">
      <div slot="title">
        <h3 style="display: inline;">{{$t('exam.viewQuestionStem')}}</h3>
        <a-divider type="vertical"></a-divider>
        <Voice v-if="userPaperInfo.questionVoice==1" :text="currentQuestionInfo.voiceText" size="20px"/>
      </div>
      <div v-html-md="currentQuestionInfo.questionStem">
      </div>
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import  { examMixins } from '@/utils/examMixins'
import { getAction, postAction } from '@/api/manage'
import { getQiniuUrl,getQiniuFile } from '@/utils/qiniu.js'
import JEllipsis from "@/components/jeecg/JEllipsis";
export default {
  name: 'ExamReview',
  mixins: [examMixins],
  components: {JEllipsis},
  data() {
    return {
      heightOffset: 0,
      paperId: '',
      loading: false,
      submiting: false,
      paperInfo: {}, //试卷信息
      userInfo: {}, //学生信息
      paperDepart: {}, //排课信息
      userPaperInfo: {}, //用户答题卡信息
      questions: [],
      paperQuestion: [], //已经过转换的题目信息
      questionSections:{},//题目分类信息
      paperAnswer: [], // 答题卡信息
      userPaperId: '', // 答题卡ID
      paperDescVisible: false, //试卷介绍是否可见
      editorVisible: false,
      viewStemVisible: false, //查看题干modal
      editorUrl: '',
    }
  },
  created() {
    this.userPaperId = this.$route.query.id
    this.getUserPaperInfo(this.userPaperId)
  },
  mounted() {
    let paperHeader = document.getElementById('paper-header')
    this.heightOffset = paperHeader.clientHeight + paperHeader.offsetTop
  },
  computed:{
    gotScore:function (){
      let score = 0;
      for(let i=0; i<this.paperAnswer.length;i++){
        if(this.paperAnswer[i]['gotScore'] && this.paperAnswer[i]['gotScore']>0){
          score += parseFloat(this.paperAnswer[i]['gotScore'])
        }
      }
      return score
    }
  },
  methods: {
    getQiniuUrl,
    // reviewPaper() {
    //   this.submiting = true
    //   console.log(this.paperAnswer)
    //   postAction('/teaching/teachingPaper/reviewUserPaper?id=' + this.userPaperId, this.paperAnswer).then((res) => {
    //     if (res.success) {
    //       this.userPaperId = res.result
    //     }
    //   }).finally(()=>{
    //     this.submiting = false
    //   })
    // },
    //获取答卷
    getUserPaperInfo(id) {
      this.loading = true
      this.paperQuestion = []
      return getAction(`/teaching/teachingPaper/getUserPaper?userPaperId=${id}`).then((res) => {
        if (res.success && res.result != null) {
          this.paperInfo = res.result.paper
          this.userInfo = res.result.userInfo
          this.userPaperInfo = res.result.userPaper
          this.paperDepart = res.result.paperDepart
          let questions = res.result.question
          this.parseQuestion(questions)
        } else {
          this.$message.error(res.message)
        }
      }).finally(()=>{
        this.loading = false
      })
    },
    parseQuestion(questions) {
      let currentSection = null;
      for (let qi in questions) {
        let q = questions[qi]
        console.log("parse question:", q);
        //解析题目分类
        
        if(q.questionSection){
          currentSection = qi
          this.questionSections[qi] = {
            text:q.questionSection,
            count:0,
            score:0
          }
        }
        if(currentSection!=null){
          this.questionSections[currentSection].count += 1;
          this.questionSections[currentSection].score += q.paperQuestionScore;
        }

        if (q.questionOptions != null) {
          q.questionOptions = JSON.parse(q.questionOptions)
        }
        this.paperQuestion.push(q)

        this.paperAnswer.push({ 
          id: q.answerId,
          qid: q.questionId, 
          gotScore: q.gotScore,
          reviewComment: q.reviewComment,
          myAnswer: this.parseAnswer(q.questionType, q.myAnswer), 
          myAnswerFile: q.myAnswerFile })
        //渲染填空题dom
        if(q.questionType == 4){
          this.renderGapFillingStemDom(q, qi)
        }      
      }
    },
    //请求批改试卷
    requestReviewPaper(){
      console.log(this.paperAnswer);
      let that = this
      let undoCount = 0
      for(let i=0; i<this.paperQuestion.length;i++){
        if(!this.isReviewAnswer(i)){
          undoCount++
        }
      }
      let savePaperNow = this.$t('exam.savePaperNow')
      let undoReviewCount = this.$t('exam.undoReviewCount', {undoCount:undoCount})
      this.$confirm({
        title: that.$t('exam.reviewPaper'),
        content: <div>
                  {undoCount>0?<h3 style="color:red">{undoReviewCount}</h3>:''}
                  <h2>{savePaperNow}</h2>
                  </div>,
        onOk() {
          that.reviewPaper()
        },
        onCancel() {
        },
      });
    },
    //提交批改试卷
    reviewPaper() {
      this.submiting = true
      postAction(
        `/teaching/teachingPaper/reviewUserPaper?id=${this.userPaperId}`,
        this.paperAnswer
      ).then((res) => {
        if (res.success) {
          this.$message.success(this.$t('exam.submitSuccess'))
          //TODO 批改下一个
        } else {
          this.$message.warn(res.message)
        }
      }).finally(()=>{
        this.submiting = false
      })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/p{
  margin-bottom: .5em;
}
.ant-layout {
  width: 100%;
  background: transparent;
}
.ant-layout-header {
  background: #fff;
}
.ant-layout-sider {
  background: #fff;
  text-align: center;
}
.remain-time {
  color: red;
  font-size: 20px;
}
.question-index {
  text-align: left;
  .question-section {
    margin: 10px 0px;
  }
  .ant-tag {
    height: 30px;
    width: 30px;
    font-size: 14px;
    line-height: 28px;
    margin-top: 4px;
  }
}
.paper-content {
  .question-card {
    margin-bottom: 20px;
  }
  .question-section {
    margin: 10px;
  }
  .question-stem {
    width: 100%;
    max-height: 500px;
    overflow: auto;
    span,
    > div {
      display: inline-block;
      vertical-align: top;
    }
  }
  .ant-radio-wrapper,.ant-checkbox-wrapper {
    display: block !important;
    margin-left: 0px;
    margin-bottom: .5em;
  }
  .question-options-content {
    display: inline-block;
  }
  .question-letter{
    vertical-align: top;
    margin-right: 10px;
  }
  /deep/.ant-checkbox, /deep/.ant-radio{
    vertical-align: top;
    top: 0.2em;
  }
}
</style>